import React, { useEffect, useState } from "react";
import CategoryCard from "../common/cards/CategoryCard";
// import coursesRoute from "../../routes/coursesRoute"; // Adjust the import path based on your routing setup
import { getApi } from "../../services/api";

function OurCourses() {
	const [categories, setCategories] = useState([]);

	// Fetch courses from the API
	useEffect(() => {
		const fetchCategories = async () => {
			try {
				const categories = await getApi("/courseCategory"); // Adjust the endpoint based on your setup
				setCategories(categories); // Set the fetched courses
			} catch (error) {
				console.error("Failed to fetch courses:", error);
			}
		};

		fetchCategories();
	}, []);

	// Function to randomly choose 4 courses
	const getRandomCategories = (categories) => {
		const shuffledCourses = categories.sort(() => 0.5 - Math.random());
		return shuffledCourses.slice(0, 4);
	};

	// Get 4 randomly chosen courses
	const randomCourseCategories = getRandomCategories(categories);

	return (
		<div className="mt-32 mb-20 flex flex-col justify-center items-center w-full">
			<h3 className="text-sm text-mainColor font-medium mb-4">
				Learn with us
			</h3>
			<h1 className="md:text-3xl text-xl font-semibold text-center mb-20">
				Our Online Courses
			</h1>

			<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:mx-0 mx-5">
				{randomCourseCategories.map((category) => (
					<CategoryCard key={category._id} category={category} />
				))}
			</div>
		</div>
	);
}

export default OurCourses;
